(() => {
  const STARS_WRAPPER = '.product__info-container .feefo-product-stars-widget';
  const INTERACTIVE_ELEMENT = 'button, a, [role="button"]';

  const isProductStarsClick = (event) => {
    const path = event.composedPath();

    const wrapperIndex = path.findIndex(
      (node) => node instanceof Element && node.matches(STARS_WRAPPER)
    );

    if (wrapperIndex === -1) return false;

    return path
      .slice(0, wrapperIndex)
      .some(
        (node) => node instanceof Element && node.matches(INTERACTIVE_ELEMENT)
      );
  };

  const scrollToReviews = () => {
    const reviewTarget = document.getElementById('feefo-product-review-widgetId');

    if (!reviewTarget) return;

    (reviewTarget.closest('.shopify-section') || reviewTarget).scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  };

  window.addEventListener(
    'click',
    (event) => {
      if (!isProductStarsClick(event)) return;

      scrollToReviews();
    },
    true
  );
})();